<div class="auth-wrapper">
  <div class="align-items-center grid h-full">
    <div class="col-6 h-full">
      <div class="gc-auth-leftPanel">
        <div class="gc-idnty-container">
          <div class="gc-logo">
            <a href=""><img src="../../assets/images/io-logo-green.svg" alt="io-logo.svg"/></a>
          </div>
          <div class="">
            <p class="mt-5 ">{{logoText}}</p>
          </div>
        </div>
        <div class="gc-auth-slider">
          <img src="../../assets/images/banner.svg" alt="banner.svg"/>
        </div>
      </div>
    </div>
    <div
      class="col-6 relative justify-content-center flex align-items-center h-full"
    >
      <div class="gc-auth-form-container">
        <div>
<!--          <span class="back-arrow" (click)="navigateToPreviousPage()">-->
<!--            <em class="pi pi-arrow-left"></em>-->
<!--          </span>-->
        </div>
        <h1>Setup MFA</h1>
        <p>
          Scan the QR code below with your authenticator app:
        </p>
        <div class="qrcode">
          <div class="qrUrl" *ngIf="qrcode_url"><img [src]="qrcode_url"/></div>
          <p *ngIf="totpCode">Enter the code generated by your authenticator app:</p>
          <div class="totpCode" *ngIf="totpCode">{{totpCode}}</div>
        </div>
        <form
          (ngSubmit)="verifyOneTimeCode()"
          #mfaVericationForm="ngForm"
        >

          <div class="mt-1 mb-5">
            <input type="text" pInputText [(ngModel)]="mfaCode" name="mfaCode" placeholder="Verify Authenticator Code" required >
          </div>

          <button
            type="submit"
            [disabled]="!mfaVericationForm.valid"
            class="login-btn"
          >
            Verify Code
          </button>
        </form>
      </div>

      <app-footer></app-footer>
    </div>
  </div>
</div>
<app-loader-wrapper [loading]="loading"></app-loader-wrapper>
